export const TYPE_OF_OPTION = {
    CREATE: 'create',
    UPDATE: 'update',
    CHANGE_PASSWORD: 'change-password',
    SET_PASSWORD: 'set-password'
}